import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Link from 'flarum/common/components/Link';
/**
 * A generic "discussions of some tags, as a header dropdown of direct
 * links" menu, one section per tag under its own heading - used by
 * addHelpRulesMenus.tsx (Règles, then Aide). Mirrors champis-articles' own
 * ArticlesMenu.js (entries from the forum payload) and reuses its
 * /article/:id route for each entry - links to `article` are a runtime
 * app.route() lookup, not a build-time import, so this doesn't create an
 * actual dependency on champis-articles, same soft coupling as
 * champis-others' own menu.
 *
 * A section with no discussion is left out, and the whole menu when they
 * all are. Each section's discussions are the ones chosen in the
 * extension's settings, in their order there (see HelpRulesMenus.php).
 * The headings are champis-others' "Divers" menu ones
 * (.ChampisForumsMenu-group, styled in champis-theme).
 */
export default class TagDropdownMenu extends Component {
  view() {
    // Serialized into the forum payload, keyed by tag slug (see
    // HelpRulesMenus.php) - no request of its own, and no menu popping in
    // once one comes back.
    const menus = app.forum.attribute('helpRulesMenus') || {};
    const sections = this.attrs.sections.map(section => ({
      ...section,
      discussions: menus[section.tagSlug] || []
    })).filter(section => section.discussions.length > 0);
    if (sections.length === 0) return null;
    return m(Dropdown, {
      buttonClassName: "Button Button--link",
      menuClassName: "ChampisForumsMenu-menu",
      label: this.attrs.label,
      accessibleToggleLabel: this.attrs.toggleLabel
    }, sections.map(section => [m("span", {
      className: "ChampisForumsMenu-group"
    }, section.label), section.discussions.map(discussion => m(Link, {
      className: "ChampisForumsMenu-item",
      href: app.route('article', {
        id: discussion.id
      })
    }, discussion.title))]));
  }
}
flarum.reg.add('champis-help_rules', 'forum/components/TagDropdownMenu', TagDropdownMenu);